<script setup lang="ts">
import { unitOptions } from '@/constants/dimension'
import Dropdown from 'primevue/dropdown'
import { useField } from 'vee-validate'
import { computed } from 'vue'

const props = defineProps<{
  modelValue?: any
  inputName: string
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])
const { value, errorMessage } = useField<number>(props.inputName)

const computedLengthUnit = computed({
  get: () => props.modelValue || 0,
  set: (newVal: any) => {
    value.value = newVal
    emit('update:modelValue', newVal)
  }
})
</script>

<template>
  <div class="flex flex-col w-1/4">
    <label for="totalLengthUnit">Unit:</label>
    <Dropdown
      id="totalLengthUnit"
      :disabled="disabled"
      :options="unitOptions"
      :invalid="!!errorMessage"
      optionLabel="label"
      optionValue="value"
      type="number"
      v-model="computedLengthUnit"
    />
  </div>
</template>

<style scoped></style>
